/** Stripe currencies with no minor unit. Everything else is cents. */
const ZERO_DECIMAL_CURRENCIES = new Set([
  'bif',
  'clp',
  'djf',
  'gnf',
  'jpy',
  'kmf',
  'krw',
  'mga',
  'pyg',
  'rwf',
  'ugx',
  'vnd',
  'vuv',
  'xaf',
  'xof',
  'xpf',
]);

/**
 * Narrow symbol so the mark doesn't depend on the UI locale: without it an AUD
 * amount prints "$" in en-AU but "A$" in en-US, and NZD prints "NZD" in en-AU.
 */
export function formatHeidi2UpgradeAmount(
  amount: number,
  currency: string,
  locale?: string,
  { trimZeroCents = false }: { trimZeroCents?: boolean } = {}
): string {
  const code = currency.toLowerCase();
  const major = ZERO_DECIMAL_CURRENCIES.has(code) ? amount : amount / 100;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: code.toUpperCase(),
    currencyDisplay: 'narrowSymbol',
    ...(trimZeroCents && Number.isInteger(major) ? { minimumFractionDigits: 0 } : {}),
  }).format(major);
}

/** Calendar day of `effective_at` in UTC, so a negative offset doesn't slip it back a day. */
export function formatHeidi2UpgradeEffectiveDate(
  effectiveAt: string,
  locale?: string
): string {
  const date = new Date(effectiveAt);
  if (Number.isNaN(date.getTime())) return effectiveAt;
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}
